import PageWrapper from '@erkport/components/PageWrapper';
import {getMonths, getYears} from '@erkport/services/erkport';
import React from 'react';
import ProfitabilitySummaryPage from './page';

const ProfitabilitySummary = () => {
  return (
    <PageWrapper yearsProvider={getYears} monthsProvider={getMonths}>
      {(props) => <ProfitabilitySummaryPage {...props} />}
    </PageWrapper>
  );
};

export default ProfitabilitySummary;
